import { useState, useEffect} from "react";
import "./formStyle.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { notification } from "antd";

// icon
import {
  passwordIcon,
  visibleIcon,
  invisibleIcon,
} from "../../constants/icons";

// utils
import monitorInputChange from "../../utils/monitorInputChange";

// interface
import { ErrorParams } from "../../interfaces/errorParams";
interface ResetPasswordData {
  password: string;
  confirm_password: string;
}
type NotificationType = "success" | "info" | "warning" | "error";

const API_URL = '/api/v1'

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [api, contextHolder] = notification.useNotification();
  const rptoken = searchParams.get('rptoken');
  const [formdata, setFormdata] = useState<ResetPasswordData>({
    password: "",
    confirm_password: "",
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorParams, setErrorParams] = useState<ErrorParams[]>([]);
 
  const opNotification = (
    type: NotificationType,
    message: string,
    descripton: string
  ) => {
    api[type]({
      message: message,
      description: descripton,
    });
  };


  const handleValidation = () => {
    let errorlist: any[] = [];
    if(formdata.password === "" || formdata.password.length < 6 ){
        errorlist.push({
            path: "password",
            message: "Password should be atleast 6 characters"
        })
    }
    if(formdata.confirm_password === "" || formdata.confirm_password.length < 6 || formdata.confirm_password !== formdata.password){
        errorlist.push({
            path: "confirm_password",
            message: "Password does not match!"
        })
    }
  
    setErrorParams(errorlist);

    if (errorlist.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const handleResetPassword = async() =>{
    try {
        setLoading(true)
        const validate = handleValidation();
        if(!validate){
            return false;
        }
        const data = {
          password:formdata.password,
          token: rptoken
        }
        const res = await axios.post(`${API_URL}/auth/resetpw/reset`, data);
        if(res.status === 200 && res.data.success === true){
          return navigate('/auth/signin?action=rpwrst&status=success')
        }
       

    } catch (error:any) {
        console.error("Error resetting password: ",error)
        if(error.status === 400 && error.response.data.message === "Token expired"){
            opNotification(
              "error",
              "Reset Link Expired",
              "Your password reset link is expired. Please request for a new one."
            )
        }
        if(error.status === 400 && error.response.data.error === "Invalid token"){
            opNotification(
              "error",
              "Reset Link Expired",
              "Your password reset link is expired. Please request for a new one."
            )
        }
    }
    finally{
        setLoading(false)
    }
  }

  useEffect(() =>{
    if(rptoken === "" || rptoken === null || rptoken === undefined){
      // eslint-disable-next-line
      navigate('/auth/signin')
    }
     // eslint-disable-next-line
  },[rptoken])

  useEffect(() => {
    if (errorParams.length > 0) {
      errorParams.forEach((err) => {
        let ele = document.getElementById(err.path);
        if (ele) {
          ele.style.borderColor = "#FF7875";
        }
      });
    }
    // eslist-disable-next-line
  }, [errorParams]);

  return (
    <div className="formContainer">
      {contextHolder}
      <span className="title">Reset Password</span>
      <form
        className="formHolder"
        onSubmit={(e) => {
          e.preventDefault();
          handleResetPassword();
        }}
      >
        
        <div className="inputHolder" id="password">
          <div className="iconHolder">{passwordIcon}</div>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            value={formdata.password}
            onChange={(e) => {
              setFormdata({
                ...formdata,
                password: e.target.value,
              });
              monitorInputChange("password");
            }}
            placeholder="Password"
          />
          <div
            className="iconHolder toggle"
            onClick={() => {
              setShowPassword((prev) => !prev);
            }}
          >
            {showPassword ? invisibleIcon : visibleIcon}
          </div>
        </div>
        <div className="inputHolder" id="confirm_password">
          <div className="iconHolder">{passwordIcon}</div>
          <input
            type={showConfirmPassword ? "text" : "password"}
            id="confirm_password"
            value={formdata.confirm_password}
            onChange={(e) => {
              setFormdata({
                ...formdata,
                confirm_password: e.target.value,
              });
              monitorInputChange("confirm_password");
            }}
            placeholder="Confirm Password"
          />
          <div
            className="iconHolder toggle"
            onClick={() => {
              setShowConfirmPassword((prev) => !prev);
            }}
          >
            {showConfirmPassword ? invisibleIcon : visibleIcon}
          </div>
        </div>

        <button
          type="submit"
          className="submit"
          disabled={loading ? true : false}
        >
          {loading ? "Submitting..." : "Submit"}
        </button>

        <div className="formfooter">
          <span>Or</span>
          <span
            className="link"
            onClick={() => {
              navigate("/auth/signin");
            }}
          >
            Sign in!
          </span>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
